<template>
  <v-dialog fullscreen persistent hide-overlay transition="fade-transition" v-model="open">
    <v-card tile style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%);">
      <v-btn
          dark
          outlined
          absolute
          top
          right
          class="rounded-lg"
          @click="closeDialog()"
      >Close
      </v-btn>
      <timer :direction="type === 'timer' ? 'down' : 'up'" v-show="type === 'timer' || type === 'stopwatch'"></timer>
      <contact-session-candidates v-show="type === 'candidate_selector'"></contact-session-candidates>
    </v-card>
  </v-dialog>
</template>

<script>
import EventHub from '@/events/hub';
import Timer from "@/views/Tools/GeneralTools/Timer";
import ContactSessionCandidates from "@/views/Tools/GeneralTools/ContactSessionCandidates";

export default {
  name: "GeneralToolsGlobal",
  components: {
    Timer,
    ContactSessionCandidates,
  },
  data: () => ({
    open: false,
    type: 'default'
  }),
  methods: {
    startMonitoringEvents() {
      EventHub.$on('general.tools.type', this.setType);
      EventHub.$on('general.tools.open', this.openDialog);
      EventHub.$on('general.tools.close', this.closeDialog);
    },
    stopMonitoringEvents() {
      EventHub.$off('general.tools.type', this.setType);
      EventHub.$off('general.tools.open', this.openDialog);
      EventHub.$off('general.tools.close', this.closeDialog);
    },
    setType(type) {
      this.type = type;
    },
    openDialog() {
      this.open = true;
    },
    closeDialog() {
      this.open = false;
    },
  },
  mounted() {
    this.startMonitoringEvents();
  },
  beforeDestroy() {
    this.stopMonitoringEvents();
  },
}
</script>

<style scoped>

</style>